import React from 'react';
import { AppDispatch } from 'reducers/index';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { LightBulb2 } from '@zola/zola-ui/src/assets/images/icons';
import { isMobile } from 'lib/responsive';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import AppleMailIcon from 'assets/images/digitalSaveTheDate/applemail-icon.jpg';
import OutlookIcon from 'assets/images/digitalSaveTheDate/outlook-icon.jpg';
import GmailIcon from 'assets/images/digitalSaveTheDate/gmail-icon.jpg';
import styles from './styles.module.less';

export type DigitalOnCopyTemplateProps = {
  onConfirm: () => void;
};

const DigitalOnCopyTemplate = (props: DigitalOnCopyTemplateProps): JSX.Element => (
  <div className={styles.digitalTipsContainer}>
    <CircleIcon image={LightBulb2} size={100} variant="cream" />
    <div className={styles.header}>Copied and ready for you to paste</div>
    <div className={styles.content}>
      <ol className={styles.digitalTipsList}>
        <li>Start a new email</li>
        <li>Paste in this message, and the emails of your guests</li>
        <li>Send!</li>
      </ol>
      <div>You can use this template on your favorite providers</div>
      <div className={styles.emailProviders}>
        <img src={GmailIcon} alt="gmail" width="42" />
        <img src={AppleMailIcon} alt="apple mail" width="42" />
        <img src={OutlookIcon} alt="outlook" width="42" />
      </div>
      <div>
        <span role="img" aria-label="advice">
          💡{' '}
        </span>
        Pro Tip: Put guests&apos; emails in the BCC line to hide the list.
      </div>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={props.onConfirm} fullWidth={isMobile()}>
        Got It
      </ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalOnCopyTemplate);
